import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return data?.map(d => ({
      ...d,
      text: `${d.postal_address.address_line1}-${d.postal_address.city}`,
    }))
  }, [data])
}
